import React, { Component } from "react";
import { Link, utils } from "@ltfe/ltfe-core-lib";
import LinearGradient from "@jdreact/jdreact-core-linear-gradient";
import { View, StyleSheet } from "react-native";
import {
    JDText,
    JDPopupWindow,
    JDImage,
    JDTouchable,
    JDShare
} from "@jdreact/jdreact-core-lib";
const { pt } = utils;
class GroupBuyingProgress extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { scheduledPlayInfo } = this.props;
        const { minTicketNum, joinTicketNum, stopSaleMinute } = scheduledPlayInfo;
        const progressValue = (joinTicketNum/minTicketNum*100).toFixed(2) + '100%';
        const diffNum = minTicketNum - joinTicketNum;
        return (
            <View style={st.progress}>
                <View style={st.progress_top} />
                <View style={st.progress_info}>
                    <View style={st.progress_info_people}>
                        <JDText
                            style={st.progress_info_people_text_number}
                            type="regular"
                        >
                            {minTicketNum}
                        </JDText>
                        <JDText style={st.progress_info_people_text}>
                            人开场，还差
                        </JDText>
                        <JDText
                            style={[
                                st.progress_info_people_text_number,
                                st.progress_info_people_text_number_red,
                            ]}
                            type="regular"
                        >
                            {diffNum}
                        </JDText>
                        <JDText style={st.progress_info_people_text}>人</JDText>
                    </View>
                    <View style={st.progress_info_time}>
                        <JDText style={st.progress_info_time_text}>
                            {stopSaleMinute} 截止
                        </JDText>
                    </View>
                </View>
                <View style={st.progress_line}>
                    <View style={[st.progress_line_current, { width: progressValue }]}>
                        <LinearGradient
                            style={[
                                st.progress_line_current_value,
                                { borderWidth: 0 },
                            ]}
                            colors={["#FF7E75", "#FA4848"]}
                            start={{ x: 0, y: 0 }}
                            end={{ x: 1, y: 0 }}
                        />
                        <View style={st.progress_line_current_point} />
                    </View>
                </View>
            </View>
        );
    }
    hide = () => {
        this.props && this.props.onHide();
    };
}
const st = StyleSheet.create({
    progress: {
        width: "100%",
        paddingLeft: pt(15),
        paddingRight: pt(15),
        paddingBottom: pt(15),
    },
    progress_top: {
        height: pt(1),
        width: "100%",
        backgroundColor: "#0000000D",
        marginBottom: pt(16),
    },
    progress_info: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        height: pt(20),
        marginBottom: pt(16),
    },
    progress_info_people: {
        flexDirection: "row",
        alignItems: "center",
        height: pt(20),
    },
    progress_info_people_text: {
        fontSize: pt(14),
        color: "#000000",
        letterSpacing: pt(1),
        fontFamily: "PingFangSC-Medium",
    },
    progress_info_people_text_number: {
        fontSize: pt(14),
        color: "#000000",
        letterSpacing: pt(1),
    },
    progress_info_people_text_number_red: {
        color: "#F0250F",
    },
    progress_info_time: {
        flexDirection: "row",
        alignItems: "center",
        height: pt(20),
    },
    progress_info_time_text: {
        fontSize: pt(12),
        color: "#FA2714",
        fontFamily: "PingFangSC-Regular",
    },
    progress_line: {
        height: pt(8),
        width: "100%",
        backgroundColor: "#FFEEEC",
        borderRadius: pt(2),
        overflow: 'hidden',
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
    },
    progress_line_current: {
        height: pt(8),
        position: "relative",
        paddingRight: pt(4),
    },
    progress_line_current_value: {
        width: "100%",
        height: pt(8),
        borderRadius: pt(2),
    },
    progress_line_current_point: {
        width: pt(8),
        height: pt(8),
        borderRadius: pt(5),
        backgroundColor: "#FA2714",
        borderColor: "#ffffff",
        borderWidth: pt(1),
        position: "absolute",
        right: pt(0),
        top: pt(0),
    },
});
export default GroupBuyingProgress;